import React, { Component } from 'react';

class DemographicForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      age: '',
      gender: '',
      originCountry: '',
      residenceCountry: '',
      student: false,
    };
  }

  handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    this.setState({ [name]: type === 'checkbox' ? checked : value });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { name, age, gender, student, originCountry, residenceCountry } = this.state;
    const newData = { 
      name, 
      age, 
      gender, 
      student, 
      origin_country_id: originCountry, 
      residence_country_id: residenceCountry 
    };
    this.props.onNavigate(newData);
  };

  render() {
    const { countries } = this.props;
    const { name, age, gender, originCountry, residenceCountry, student } = this.state;

    return (
      <div>
        <form onSubmit={this.handleSubmit}>
          <header className='form-header'>
            <h1>Demographic information</h1>
          </header>
          <div className="form-container">
            <div className='input-field-regular'>
              <input 
                type="number"
                name="age"
                value={age}
                onChange={this.handleChange}
                placeholder="Enter your age"
                min="0"
                required
              />
            </div> 
            <select name="gender" className='input-field-regular' value={gender} onChange={this.handleChange} required>
              <option value="">Select your gender</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
            </select>
            <div>
              <select name="originCountry" className='input-field-regular' value={originCountry} onChange={this.handleChange} required>
                <option value="" disabled>Select country of origin</option>
                {countries.map((country) => (
                  <option key={country.country_id} value={country.country_id}>
                    {country.country_name}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <select name="residenceCountry" className='input-field-regular' value={residenceCountry} onChange={this.handleChange} required>
                <option value="" disabled>Select country of residence</option>
                {countries.map((country) => (
                  <option key={country.country_id} value={country.country_id}>
                    {country.country_name}
                  </option>
                ))}
              </select>
            </div>
            <div className='input-Student'>
              <label className='date-label'>Student:</label>
              <input
                type="checkbox"
                className="accessible-checkbox"
                name="student"
                checked={student}
                onChange={this.handleChange}
              />
            </div>
          </div>
          <button type="submit">Submit</button>
        </form>
      </div>
    );
  }
}

export default DemographicForm;
